/**
 * Which seeded assistant messages still have to *arrive* rather than simply be
 * there.
 *
 * A page summary is dropped into a thread as a finished assistant message — the
 * text is already known, so there is no stream to watch. Rendering it as
 * settled history would have the user land on a chat that looks like one they
 * already had. Playing it in makes the chat read as something happening now:
 * Sofia thinks for a moment, then the summary types itself out.
 *
 * Kept OUT of the persisted chat-item model on purpose. This is presentation
 * state for one appearance, not a property of the message: a reload starts with
 * an empty registry, so a summary the user has already watched arrive is plain
 * history from then on.
 */

const pendingRevealIds = new Set<string>()

/** Mark a seeded item to play in the next time it mounts. */
export function markSummaryItemForReveal(itemId: string): void {
  pendingRevealIds.add(itemId)
}

export function isSummaryItemPendingReveal(itemId: string): boolean {
  return pendingRevealIds.has(itemId)
}

/**
 * Retire an item's reveal. Called when the animation finishes or its view goes
 * away — either way that message has had its one arrival.
 */
export function clearSummaryItemReveal(itemId: string): void {
  pendingRevealIds.delete(itemId)
}
